import { formatMoney } from 'libs/shopify'
import SaleOffPrice from 'snippets/sale-off-price/sale-off-price'

function ProductCardPrice({ type, price, variant, hasSaleTag = false }) {
  return (
    <p className="text-base font-bold text-grey-900">
      {type === 'add' ? (
        <VariantPrice price={variant.price} comparePrice={variant.compare_at_price} hasSaleTag={hasSaleTag} />
      ) : (
        `From ${formatMoney(price)}`
      )}
    </p>
  )
}

function VariantPrice({ price, comparePrice, hasSaleTag = false }) {
  const saleOff =
    comparePrice && comparePrice > price ? Math.round(((comparePrice - price) / comparePrice) * 100) : null

  const { was, rrp } = translate.product

  return (
    <>
      <div className="flex flex-wrap items-center gap-1">
        {formatMoney(price)}{' '}
        {saleOff && (
          <SaleOffPrice
            saleOff={saleOff}
            hasSaleTag={hasSaleTag}
            className="py-0.5 pl-0.5 pr-1.5 text-xs tracking-[-0.1px]"
          />
        )}
      </div>
      {saleOff && (
        <s className="mt-1 text-sm font-semibold text-grey-500">
          {hasSaleTag ? was : rrp} {formatMoney(comparePrice)}
        </s>
      )}
    </>
  )
}

export default ProductCardPrice
